import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MarketplaceService } from '@purespectrum1/ui/marketplace';
import { BuyerSurveyResponse } from '@purespectrum1/ui/marketplace/shared/interfaces/survey.interface';

import { AuthState } from '@purespectrum1/ui/marketplace/shared/interfaces/auth.interface';
import { ModalService } from '@purespectrum1/ui/modal';
import { AuthService } from '../../auth/auth.service';
import { ServiceAccountModalComponent } from '../../layout/header/user-menu/service-account-modal/service-account-modal.component';
import { MultiBuyerModalComponent } from './../../create-surveys/multi-buyer-modal/multi-buyer-modal.component';
import { BuyerApiService } from '../../shared/services/buyer-api/survey.service';
import { MultiBuyerService } from '../../../app/shared/services/multi-buyer/multi-buyer-service';

@Component({
  selector: 'ps-survey-launch',
  templateUrl: './survey-launch.component.html',
  styleUrls: ['./survey-launch.component.css'],
})
export class SurveyLaunchComponent implements OnInit, OnDestroy {
  private _subscriptions = new Subscription();
  public surveyId!: number;
  public auth: AuthState = this._auth.getMarketplaceAuth;
  public buyerSurvey: BuyerSurveyResponse = {} as BuyerSurveyResponse;
  public isMultiBuyerParent: boolean = false;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _auth: AuthService,
    private _marketplaceService: MarketplaceService,
    private _modal: ModalService,
    private readonly _buyerApiService: BuyerApiService,
    private readonly _multiBuyerService: MultiBuyerService
  ) {}

  ngOnInit(): void {
    this._subscriptions.add(
      this._route.params.subscribe((params) => {
        this.surveyId = params['id'];
      })
    );

    this._subscriptions.add(
      this._auth.loggedInAsServiceBuyer$.subscribe((data) => {
        this.auth = this._auth.getMarketplaceAuth;
      })
    );

    this.isMultiBuyerParent = this._auth.isLoggedInAsMultiBuyer();

    if (this._auth.isSelectedMultiBuyerCompany()) {
      this.auth = this._auth.getMarketplaceAuth;
    }

    this._subscriptions.add(
      this._marketplaceService
        .onUpdateSurveyComplete()
        .subscribe((response) => {
          if (response.survey?.ps_survey_id && response.action === 'LiveEdit') {
            this._router.navigateByUrl(
              `/dashboard/${response.survey.ps_survey_id}`
            );
          }
        })
    );

    this._subscriptions.add(
      this._buyerApiService
        .getSurvey(this.surveyId, 0, false)
        .subscribe((response) => {
          this.buyerSurvey = response;

          if (this.isMultiBuyerParent) {
            this.setSelectedMultiBuyer();
          }
        })
    );
  }

  setSelectedMultiBuyer() {
    const cmpId =
      this.auth.selectedMultiBuyerCompany?.parentCompany ?? this.auth.user?.cmp;
    const targetBuyerId = this.buyerSurvey.buyer_company;

    this._multiBuyerService.selectBuyerPromise(cmpId!, targetBuyerId);
  }

  goToDashboard(close: boolean) {
    if (close) {
      this._router.navigateByUrl('/dashboard');
    }
  }

  selectBuyer(open: boolean) {
    if (open) {
      this._modal.open(ServiceAccountModalComponent, {});
    }
  }
  selectMultiBuyer() {
    const cmpId =
      this.auth.selectedMultiBuyerCompany?.parentCompany ?? this.auth.user?.cmp;
    this._modal.open(MultiBuyerModalComponent, {
      data: { cmpId: cmpId },
    });
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
